import { Card } from "@/src/components/cards";
import { openConfirmDialog } from "@/src/components/dialogs";
import { Hospitalisation, Patient, TransferDemand } from "@/src/data/allTypes";
import apiFetch from "@/src/utils/apiFetch";
import {
  formatDate,
  getDayCount,
  getItemId,
  getUserId,
  getUserShortName,
  isToday,
} from "@/src/utils/utils";
import openEvolutionItemStandardForm from "../openEvolutionItemStandardForm";
import { getStandardConfidentiality } from "../../patients/confidentialitiesHook";

export default function TransferDemandCard({
  item,
  patient,
  parent,
  onClick,
  onChange,
}: {
  item: TransferDemand;
  patient: Patient;
  parent: Hospitalisation;
  onClick: () => void;
  onChange: (item: TransferDemand) => void;
}) {
  function getStatusName(item: TransferDemand) {
    if (item.status == "pending") return "En attente";
    if (item.status == "waitingForValidation") return "En attente";
    if (item.status == "validated") return "Validée";
    if (item.status == "finished") return "Terminée";
    if (item.status == "canceled") return "Rejetée";
    return "";
  }

  return (
    <Card
      color={"blue"}
      leading={
        <div className=" mtop5 left br mright5">
          <div className="bold">{getDayCount(parent?._date, item._date)}</div>
          <div className="gray">{formatDate(item._date, "HH:mm")}</div>
        </div>
      }
      title={`Transfert (${getStatusName(item)})`}
      subTitle={
        <div>
          <div>Demandée par {getUserShortName(item.creator)}</div>
          {item.acceptedBy != null && (
            <div>Acceptée par {getUserShortName(item.acceptedBy)}</div>
          )}
        </div>
      }
      onClick={async () => {
        await onClick();
      }}
      onDelete={
        getUserId() == getItemId(item.creator) && isToday(item._date)
          ? async () => {
              await openConfirmDialog({
                content: "Voulez-vous vraiment supprimer cet élément ?",
                onConfirm: async () => {
                  await apiFetch("transferDemands", "deleteOne", {
                    id: item.id,
                  });
                  onChange?.(item);
                },
              });
            }
          : undefined
      }
    >
      <div>
        Vers {item.service?.name} {item.bed?.name} {item.unit?.name}
      </div>
    </Card>
  );
}
